import React from 'react';
import PropTypes from 'prop-types'

const IconCalendar = props => {
  const color = props.color || '#585858';
  return (
    <svg width={24} height={27} viewBox="0 0 24 27" {...props}>
      <title>Group 21</title>
      <g fill="none" fillRule="evenodd">
        <path
          stroke={color}
          strokeWidth={1.5}
          d="M1.059 1.058v24.417h21.809V1.058z"
        />
        <path
          d="M7.372 13.276a1.147 1.147 0 11-2.295-.002 1.147 1.147 0 012.295.002M13.111 13.276a1.147 1.147 0 11-2.295-.002 1.147 1.147 0 012.295.002M18.85 13.276a1.147 1.147 0 11-2.294-.002 1.147 1.147 0 012.295.002M7.372 19.16a1.148 1.148 0 11-2.296 0 1.148 1.148 0 012.296 0M13.111 19.16a1.148 1.148 0 11-2.295 0 1.148 1.148 0 012.295 0M18.85 19.16a1.148 1.148 0 11-2.295 0 1.148 1.148 0 012.296 0"
          fill={color}
        />
        <path
          d="M.426 6.922h23.22M6.706 1.43v2.824M16.588 1.43v2.824"
          stroke={color}
          strokeWidth={1.5}
        />
      </g>
    </svg>
  );
};

IconCalendar.propTypes = {
  color: PropTypes.string
}

export default IconCalendar;
